import { language, backendUrl } from '@/util/config';
export default async function getCheckout(currency: string = "EUR") {
    const queryParams = {
      t: Date.now()
    }

    // we add body attributes stating with data-add- as note attributes to the shopify order
    const attributes = document.body.attributes
    for (const attribute of attributes) {
      if (attribute.nodeName.startsWith('data-add-')) {
        queryParams[attribute.nodeName.replace('data-', '')] = attribute.nodeValue
      }
    }

    // set data for small poster ab test
    const smallPosterTestValue = localStorage.getItem("smallPosterABTest")
    if (smallPosterTestValue && smallPosterTestValue !== "notEligibleForTest") {
      queryParams['add-smallPosterABTest'] = smallPosterTestValue
    }
    // set glicd
    const gclid = localStorage.getItem('starmapGclid')
    if (gclid) {
      queryParams['add-gclid'] = gclid
    }

    const starPosterTrackingConsent = localStorage.getItem('COOKIE_CONSENT_OVERALL_STATUS');
    const mvpTrackingConsent = localStorage.getItem('trackingConsent');
    const trackingConsent = starPosterTrackingConsent || mvpTrackingConsent;
    queryParams['add-trackingConsentGranted'] = (trackingConsent === "ACCEPTS_ALL" || trackingConsent === '"ALL"') ? "true" : "false";

    const queryString = Object.keys(queryParams).map(k => k+"="+encodeURIComponent(queryParams[k])).join('&')
    // we add the current time to prevent the request from being cached and therefore showing stale data
    const checkout = await fetch(backendUrl + '/cart/checkout/' + language + "/" + currency + "?"+queryString, {
      method: 'GET',
      credentials: 'include',
    });
    if (checkout.status < 300) {
      const url = await checkout.text();
      return url;
    } else {
      throw new Error('Could not refresh EUR checkout url. Server sent ' + checkout.status + ' ' + await checkout.text())
    }
  }